import "bootstrap/dist/css/bootstrap.min.css";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";

function PokemonCard({el}) {
  return (
        <Card style={{ width: "18rem" }} className="m-2 bg-dark text-white" >
          <Card.Img variant="top" src={el.foto}/>
          <Card.Body>
            <Card.Title><b>Nombre:</b> {el.nombre}</Card.Title>
            <Card.Text>
        <b>Alto:</b> {el.alto}
            </Card.Text>
            <Button variant="primary">Ver más</Button>
          </Card.Body>
        </Card>
  );
}

export default PokemonCard;
 